import React from 'react';
import { useNavigate } from 'react-router-dom';
import './ProfileManageAccount.css';

interface ActionCardProps {
  icon: React.ReactNode;
  title: string;
  description: string;
  buttonText: string;
  onButtonClick?: () => void;
  variant?: 'deactivate' | 'delete';
}

const ProfileManageAccount: React.FC = () => {
  const navigate = useNavigate();

  const handleDeactivate = () => {
    // Mock deactivation logic
    console.log('Deactivate account clicked');
  };

  const handleDelete = () => {
    // Mock deletion logic
    console.log('Delete account clicked');
  };

  const ActionCard: React.FC<ActionCardProps> = ({ 
    icon, 
    title, 
    description, 
    buttonText, 
    onButtonClick,
    variant = 'deactivate'
  }) => (
    <div className="manage-account-card">
      <div className="manage-account-card-header">
        <div className="manage-account-icon-wrapper">
          {icon}
        </div>
        <div className="manage-account-text-content">
          <h3 className="manage-account-card-title">{title}</h3>
          <p className="manage-account-card-description">{description}</p>
        </div>
      </div>
      <button 
        className={`manage-account-button manage-account-button--${variant}`}
        onClick={onButtonClick}
      >
        {buttonText}
      </button>
    </div>
  );

  return (
    <div className="manage-account-container">
      {/* Header */}
      <div className="manage-account-header">
        <button className="manage-account-back-button" onClick={() => navigate('/profile-security')}>
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M10 12L6 8L10 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>
        <h1 className="manage-account-header-title">Manage Account</h1>
      </div>

      {/* Deactivate Account Card */}
      <ActionCard
        icon={
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M18 8C19.6569 8 21 6.65685 21 5C21 3.34315 19.6569 2 18 2C16.3431 2 15 3.34315 15 5C15 6.65685 16.3431 8 18 8Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M6 15C7.65685 15 9 13.6569 9 12C9 10.3431 7.65685 9 6 9C4.34315 9 3 10.3431 3 12C3 13.6569 4.34315 15 6 15Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M18 22C19.6569 22 21 20.6569 21 19C21 17.3431 19.6569 16 18 16C16.3431 16 15 17.3431 15 19C15 20.6569 16.3431 22 18 22Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M8.59 13.51L15.42 17.49" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M15.41 6.51L8.59 10.49" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        }
        title="Deactivate Account"
        description="Temporarily disable your account. You can reactivate it anytime by logging back in."
        buttonText="Deactivate Account"
        onButtonClick={handleDeactivate}
        variant="deactivate"
      />

      {/* Delete Account Card */}
      <ActionCard
        icon={
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M3 6H5H21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M8 6V4C8 3.46957 8.21071 2.96086 8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2H14C14.5304 2 15.0391 2.21071 15.4142 2.58579C15.7893 2.96086 16 3.46957 16 4V6M19 6V20C19 20.5304 18.7893 21.0391 18.4142 21.4142C18.0391 21.7893 17.5304 22 17 22H7C6.46957 22 5.96086 21.7893 5.58579 21.4142C5.21071 21.0391 5 20.5304 5 20V6H19Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M10 11V17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M14 11V17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        }
        title="Delete Account"
        description="Permanently delete your account and all associated data. This action cannot be undone."
        buttonText="Delete Account"
        onButtonClick={handleDelete}
        variant="delete"
      />
    </div>
  );
};

export default ProfileManageAccount;